import { createContext } from 'react';

interface IFormContext {
  mutations: any;
}

const FormContext = createContext<IFormContext>({ mutations: {} });

export default FormContext;
